export default __webpack_public_path__ + "static/media/tajima.2fe01f44.png";